var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57.8711 31.8808L75.9676 21.2539V84.1193L57.8711 94.7462V31.8808Z",
    fill: "#287ABD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8719 94.7462L39.7745 84.1193V21.2539L57.8719 31.8808V94.7462Z",
    fill: "#4EA9E4"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.0623 94.7462L75.9675 84.1193V21.2539L94.0623 31.8808V94.7462Z",
    fill: "#F7BA4B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21.6805 31.8823V31.8808V94.7462L39.7753 84.1193V21.2539L21.6805 31.8808V31.8823Z",
    fill: "#F7BA4B"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M3.58493 21.2549V84.1202L21.6806 94.7472V31.8818L3.58493 21.2549Z",
    fill: "#4EA9E4"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9683 84.1191L94.0623 94.7461L57.8727 116L21.6814 94.7461L39.7745 84.1191L57.871 94.7461L75.9683 84.1191Z",
    fill: "#EDB55B"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M112.159 21.2539V84.1193L94.0632 94.7462V31.8808L112.159 21.2539Z",
    fill: "#287ABD"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M75.9676 21.2541L57.8706 31.8808L39.7745 21.2541L21.6806 31.8808L3.58493 21.2539L39.7745 0L57.8706 10.6269L75.9676 0L112.159 21.2539L94.0615 31.8808L75.9676 21.2541Z",
    fill: "#3490CD"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b390a77c.svg";
export { ForwardRef as ReactComponent };